var plugin_rtlignore_default = {
  "alignLeft": "svOza",
  "textWrapNowrap": "RBgp5",
  "alignRight": "VD11y",
  "alignCenter": "cHDnD",
  "sizeFullWidth": "oTZ08",
  "renderedInTable": "umZ7K",
  "sizeOriginal": "_7LnQk",
  "sizeContent": "amcJ-",
  "sizeSmall": "_7MWJl",
  "sizeSmallCenter": "SV47S",
  "flex": "NS7O-",
  "atomic": "APGwu",
  "embed": "_0Xp9p",
  "horizontalScrollbar": "rxC4C",
  "pluginContainerMobile": "OoAsN"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
